import React, { useState, useEffect, useRef } from "react";
import "./receipt.css";
import logo from "./img/edaplogo.png";
import QRCode from "qrcode";
import signature from "./img/uncr_sig.jpg";
import html2pdf from "html2pdf.js";
import { Delete, Download, Eye } from "react-feather";
import { Modal, Button, ConfigProvider } from 'antd';
import app from "./firebase.js";
import { getDatabase, ref, set, push, onValue, remove } from "firebase/database";

function Receipt() {
  const [formData, setFormData] = useState({
    Names: "",
    Faculty: "",
    Department: "",
    Class: "",
    Matricule: "",
    "Academic year": "",
    Amount: "",
    reason: "",
    source: "",
    date: "",
    ref: "",
    image: null,
  });

  const [receipts, setReceipts] = useState([]);
  const [receiptModalVisible, setReceiptModalVisible] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  const db = getDatabase(app);

  // Load receipts from Firebase on component mount
  useEffect(() => {
    const receiptsRef = ref(db, "receipts/UNCR/");
    onValue(receiptsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const receiptArray = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setReceipts(receiptArray);
      }
    });
  }, [db]);

  const handleChange = async (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prevData) => ({
          ...prevData,
          [name]: reader.result, // Save Base64 string of the image
        }));
      };
      if (file) reader.readAsDataURL(file);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleCreateReceipt = () => {
    if (formData.Names.trim() === "" || formData.Matricule.trim() === "") {
      alert("Name and Matricule fields cannot be empty!");
      return;
    }

    const newReceipt = { ...formData };
    setReceipts([...receipts, newReceipt]);
    const db = getDatabase(app);
    const receiptRef = ref(db, `receipts/UNCR/${formData.Matricule}`); // Save under matricule key

    set(receiptRef, {
      ...newReceipt,
    })
      .then(() => {
        console.log('Receipt saved successfully in Firebase');
      })
      .catch((error) => {
        console.error('Error saving receipt to Firebase: ', error);
      });

    // Reset form
    setFormData({
      Names: "",
      Faculty: "",
      Department: "",
      Class: "",
      Matricule: "",
      "Academic year": "",
      Amount: "",
      reason: "",
      source: "",
      date: "",
      ref: "",
      image: null,
    });
  };


  const handleDeleteReceipt = (id) => {
    const receiptRef = ref(db, `receipts/UNCR/${id}`);
    remove(receiptRef)
      .then(() => {
        console.log("Receipt deleted successfully from Firebase");
      })
      .catch((error) => {
        console.error("Error deleting receipt from Firebase: ", error);
      });
  };

  const showReceiptModal = (receipt) => {
    setSelectedReceipt(receipt);
    setReceiptModalVisible(true);
  };

  const handleReceiptModalClose = () => {
    setReceiptModalVisible(false);
    setSelectedReceipt(null);
  };

  // Handle ESC key press to close modal
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && receiptModalVisible) {
        handleReceiptModalClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [receiptModalVisible]);

  return (
    <div className="uncr-receipt-wrapper">
      <div className="recu">
      <div className="page-image">
        <img src={logo} alt="University Logo" />
      </div>
      <div>
        <input
          className="finput"
          type="text"
          name="Names"
          placeholder="Nom et prenom"
          value={formData.Names}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Faculty"
          placeholder="Faculty"
          value={formData.Faculty}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Department"
          placeholder="Department"
          value={formData.Department}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="text"
          name="Class"
          placeholder="Class"
          value={formData.Class}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Matricule"
          placeholder="Matricule"
          value={formData.Matricule}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Academic year"
          placeholder="Anée Académique"
          value={formData["Academic year"]}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="text"
          name="Amount"
          placeholder="Montant"
          value={formData.Amount}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="reason"
          placeholder="Motif"
          value={formData.reason}
          onChange={handleChange}
        />
        {/* <input
          className="finput"
          type="text"
          name="source"
          placeholder="Source de paiement (ex: Western Union)"
          value={formData.source}
          onChange={handleChange}
        /> */}
        <input
          className="finput"
          type="date"
          name="date"
          placeholder="Date"
          value={formData.date}
          onChange={handleChange}
        />
        <br />
        {/* <input
          className="finput"
          type="text"
          name="ref"
          placeholder="N° de Reference"
          value={formData.ref}
          onChange={handleChange}
        /> */}
        <input
          className="finput"
          type="file"
          name="image"
          id="f-img"
          accept="image/*"
          onChange={handleChange}
        />
        <br />
        <div className="fbtn">
          <button className="fbutton" onClick={handleCreateReceipt}>
            Créer reçu
          </button>
        </div>
      </div>

      <div className="receipt-list">
        {receipts.map((receipt, index) => (
          <div key={receipt.id} className="receipt-item">
            <button
              className="receipt-toggle"
              onClick={() => showReceiptModal(receipt)}
            >
              <Eye size={16} style={{ marginRight: '8px' }} />
              {receipt.Names} - {receipt.Matricule}
            </button>
            <button
              className="receipt-delete-btn"
              onClick={() => handleDeleteReceipt(receipt.id)}
            >
              <Delete size={15} />
            </button>
          </div>
        ))}
      </div>

      {/* Modal for receipt preview - Scoped to prevent conflicts */}
      <ConfigProvider
        theme={{
          token: {
            // Prevent Ant Design from affecting global styles
          }
        }}
      >
        <Modal
          title={
            <span style={{ color: 'white' }}>
              {selectedReceipt ? `Reçu - ${selectedReceipt.Names}` : 'Aperçu du Reçu'}
            </span>
          }
          open={receiptModalVisible}
          onCancel={handleReceiptModalClose}
          width="95vw"
          style={{ top: 10 }}
          className="receipt-modal"
          centered={false}
          maskClosable={true}
          keyboard={true}
          footer={[
            <Button
              key="download"
              type="primary"
              icon={<Download size={16} />}
              onClick={() => selectedReceipt && downloadReceiptPDF(selectedReceipt)}
              style={{
                backgroundColor: '#28a745',
                borderColor: '#28a745',
                fontWeight: 'bold'
              }}
            >
              Télécharger PDF
            </Button>,
            <Button
              key="close"
              onClick={handleReceiptModalClose}
              style={{ fontWeight: 'bold' }}
            >
              Fermer
            </Button>
          ]}
        >
          {selectedReceipt && (
            <div className="receipt-modal-content">
              <ReceiptTemplate formData={selectedReceipt} />
            </div>
          )}
        </Modal>
      </ConfigProvider>
    </div>
    </div>
  );
}

const ReceiptTemplate = ({ formData }) => {
  const now = new Date().toLocaleDateString();
  const receiptQrCodeRef = useRef();

  useEffect(() => {
    const generateReceiptQRCode = async () => {
      const receiptQrData = `RECEIPT - UNCR PAYMENT CONFIRMATION
Name: ${formData.Names}
Faculty: ${formData.Faculty}
Department: ${formData.Department}
Class: ${formData.Class}
Matricule: ${formData.Matricule}
Amount: ${formData.Amount}
Reason: ${formData.reason}
Date: ${formData.date}
Verification: Receipt Confirmed
Issued by: UNCR - Académie du Cercle de Réflexion des Nations`;

      try {
        const receiptQrCodeUrl = await QRCode.toDataURL(receiptQrData, {
          width: 120,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        if (receiptQrCodeRef.current) {
          receiptQrCodeRef.current.src = receiptQrCodeUrl;
        }
      } catch (error) {
        console.error('Error generating receipt QR code:', error);
      }
    };

    if (formData) {
      generateReceiptQRCode();
    }
  }, [formData]);

  return (
    <div className="receipt-uncr-container">
      <div className="receipt-document-body" id={`receipt-${formData.Names}`}>
        <div className="receipt-school-header">
          <div className="receipt-institution-info">
            <h4>
              Académie du Cercle de Réflexion des Nations
            </h4>
            <img src={logo} alt="University Logo" />
            <p>
              <i>UNCR Université en cotutelle internationale de thèse</i>
              <br />
              <span>
                <strong>Status :</strong> Université publique
                <br />
                <strong>Web :</strong> crn-nations.org
                <br />
                <strong>Email :</strong> contact@crn-nations.org
                <br />
                <strong>Adress :</strong> 1522, Cleveland Street,Hollywood 33020, Florida, USA
              </span>
            </p>
          </div>
          {formData.image && (
            <img src={formData.image} alt="Student" className="receipt-student-pic" />
          )}
        </div>
        <p className="receipt-content-text">
          Reçu de : <strong>{formData.Names} </strong>
          la somme de: <strong>{formData.Amount} </strong>
          <br/>
          versée le <strong>{formData.date} </strong> pour :{" "}
           <strong>{formData.reason} </strong>
          <br />
          a été vérifié et confirmé par le service de comptabilité UNCR/Unilis
          <br />
          <br />
          <br />
          <div style={{display: "flex", marginBottom: "-15px"} }>
            <div>
              <span><b>Signature:</b></span>
            </div>
            <div>
              <img src={signature} width={100}/>
            </div>
          </div>
            <span style={{marginTop: "-25px"}}>
              M.Argentine
              <br />
              Data Manager
            </span>
        </p>
        <div className="receipt-qr-container">
          <img 
            ref={receiptQrCodeRef} 
            alt="QR Code - Receipt Verification" 
            className="receipt-qr-code" 
          />
          {/* <p className="receipt-qr-label">Code de vérification</p> */}
        </div>
      </div>
    </div>
  );
};

  const downloadReceiptPDF = (receipt) => {
    const element = document.getElementById(`receipt-${receipt.Names}`);
    const options = {
      margin: 1,
      filename: `${receipt.Names.replace(/\s+/g, '_')}_receipt.pdf`,
      html2canvas: { scale: 2, x: -2, y: 0, backgroundColor: "none" },
      jsPDF: { format: "a4", orientation: "portrait" },
    };
    html2pdf().set(options).from(element).save();
  };

export default Receipt;
